export function isAllEqual(...arr: any[]): boolean {
  return arr.every((val) => val === arr[0])
}
